<template>
    <div>
        <label v-if="field._label" class="label" :for="name" :class="{'label_error':!!validator.failed}" v-html="field._label">
            <!--{{ field._label + (validator.required ? ' *' : '') }}-->
<!--            {{ field._label }}-->
        </label>
    </div>
</template>

<script>
export default {
    props: ['name', 'field', 'validator']
}
</script>
